"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.personaAccountsOrganizationResultFactory = void 0;
const Factory = require("factory.ts");
const Profiles_1 = require("../Profiles");
const persona_account_organization_factory_1 = require("./persona-account-organization.factory");
exports.personaAccountsOrganizationResultFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    persona: Profiles_1.personaFactory.build(),
    accounts: persona_account_organization_factory_1.personaAccountOrganizationFactory.buildList(2),
});
